/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Whtr_Band_Note_LowInputs */

const en_us2_body_assessment_whtr_band_note_low = /** @type {(inputs: Body_Assessment_Whtr_Band_Note_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your waist is under 40% of your height. That can point to being underweight. Worth raising with a health professional.`)
};

const pt_br2_body_assessment_whtr_band_note_low = /** @type {(inputs: Body_Assessment_Whtr_Band_Note_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A sua cintura está abaixo de 40% da altura. Isso pode indicar magreza excessiva. Vale conversar com um profissional de saúde.`)
};

const es_419_body_assessment_whtr_band_note_low = /** @type {(inputs: Body_Assessment_Whtr_Band_Note_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu cintura está por debajo del 40% de tu estatura. Eso puede indicar bajo peso. Vale la pena hablarlo con un profesional de la salud.`)
};

const pt_pt2_body_assessment_whtr_band_note_low = /** @type {(inputs: Body_Assessment_Whtr_Band_Note_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tua cintura está abaixo de 40% da altura. Isso pode indicar magreza excessiva. Vale a pena falares com um profissional de saúde.`)
};

const fr_fr2_body_assessment_whtr_band_note_low = /** @type {(inputs: Body_Assessment_Whtr_Band_Note_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton tour de taille est inférieur à 40 % de ta hauteur. Cela peut indiquer une maigreur excessive. Parles-en à un professionnel de santé.`)
};

const de_de2_body_assessment_whtr_band_note_low = /** @type {(inputs: Body_Assessment_Whtr_Band_Note_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Taille liegt unter 40 % deiner Größe. Das kann auf Untergewicht hindeuten. Sprich am besten mit einer Fachperson aus dem Gesundheitswesen darüber.`)
};

const it_it2_body_assessment_whtr_band_note_low = /** @type {(inputs: Body_Assessment_Whtr_Band_Note_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tua vita è sotto il 40% dell'altezza. Può indicare sottopeso. Vale la pena parlarne con un professionista della salute.`)
};

/**
* | output |
* | --- |
* | "Your waist is under 40% of your height. That can point to being underweight. Worth raising with a health professional." |
*
* @param {Body_Assessment_Whtr_Band_Note_LowInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_whtr_band_note_low = /** @type {((inputs?: Body_Assessment_Whtr_Band_Note_LowInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Whtr_Band_Note_LowInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_whtr_band_note_low(inputs)
	if (locale === "es-419") return es_419_body_assessment_whtr_band_note_low(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_whtr_band_note_low(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_whtr_band_note_low(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_whtr_band_note_low(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_whtr_band_note_low(inputs)
	return en_us2_body_assessment_whtr_band_note_low(inputs)
});
export { body_assessment_whtr_band_note_low as "body-assessment.whtr_band_note.low" }